// extracted by mini-css-extract-plugin
export default {"wrapper":"LayoutFeedMain_wrapper__YEgDl"};